import {useState, Fragment, useRef, useEffect} from "react";
import parse from 'html-react-parser';
import {Box, Card, CardMedia, Grid, useMediaQuery, useTheme} from '@mui/material';
import {Typography} from '@mui/material';
import Button from "@mui/material/Button";
import React from 'react';
import {CurrentLesson} from "../../../interfaces/currentLesson";
import styles from './popup.module.css';
import { Promo } from "../../../interfaces/promo";
import LockIcon from '@mui/icons-material/Lock';
import { clickFinishedtProductRecommendation, clickProduct, viewProduct } from "../../mixPanelEvents/mixPanelEvents";
import { Accelerator } from "../../../interfaces/accelerator";



const getCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

const PopUpDialog = ({accelerator, currentLesson, accelName,promo, callback, source, completedCourse, scratchClubPage = false}: {
    accelerator:Accelerator,
    currentLesson: CurrentLesson,
    accelName?:string
    promo:Promo | null,
    callback?: (value: boolean) => void,
    source:string,
    completedCourse?:boolean,
    scratchClubPage?:boolean
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const [value1, setValue1] = useState(true);
    const modalBodyRef = useRef<HTMLDivElement>(null);
    const modalHeaderRef = useRef(null);
    

    useEffect(() => {
        if (promo !== undefined && promo !== null) {
            viewProduct('Video', 'Pop Up', '', "In Video", promo.name);
          }

        // // Increment videos count so that popup doesn't show on the next lesson
        // const currentDate = getCurrentDate();
        // const storedCount = parseInt(localStorage.getItem(`videoCompletionCount_${currentDate}`) || "0", 10) || 0;
        // const updatedCount = storedCount + 1;
        // localStorage.setItem(`videoCompletionCount_${currentDate}`, updatedCount.toString());
    }, []);


      
    return (
        <Box sx={{ position:{xs: "'relative'", md: ""}}}>

        {isMobile && (
            <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', // Adjust opacity as needed
                    zIndex: 1000, // Ensure the overlay is below the modal
                }}
            />
        )}
        
        <Box top="center" left="center" className={styles.lessonModal} sx={{maxHeight:isMobile? "auto":"403px", maxWidth:isMobile? "auto":"687px"}}>
            <Box className={styles.modalHeader} ref={modalHeaderRef}>
            <Fragment>
                {!isMobile ? 
                <Fragment>
                    <img className={styles.modalCloseBtn}
                    onClick={() =>  {if (callback) {
                                        callback(!value1)
                                    }}}
                    src="https://www.performancegolf.com/wp-content/uploads/2023/11/close_btn.png"
                    alt="close"/> 
                </Fragment>
                :
                <Fragment>
                        <img className={styles.modalCloseBtn}
                                onClick={() =>  {if (callback) {
                                                    callback(!value1)
                                                }}}
                                src="https://www.performancegolf.com/wp-content/uploads/2023/11/close_btn.png"
                                alt="close"/>
                    </Fragment>
                }
                </Fragment>
                <div className={styles.ribbon}
            >
                <span>RECOMMENDED FOR YOU</span>
            </div>
            </Box>
            <Box className={styles.modalBody} ref={modalBodyRef} sx={{fontFamily: "Lato, sans-serif"}}>
                <Grid container padding={0} margin={0} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    {promo?.promo_text && 
                        <Grid className={styles.gridTitlePopupModal} item lg={10} md={12} xs={12} padding={0} margin={0} sx={{padding:"30px 0 0 0"}}>
                            <Typography className={styles.titlePopupModalTypo} sx={{fontWeight: completedCourse? 800 : 600, fontSize: completedCourse? "25px" : "30px", textAlign: "center", lineHeight: completedCourse? "28.75px" : "39px"}}>{promo.promo_text}</Typography>
                        </Grid>
                    }
                     {!promo?.promo_text && !isMobile &&
                        <Grid className={styles.gridTitlePopupModal} item md={12} xs={12} padding={0} margin={0} sx={{padding:"30px 0 0 0"}}>
                            <Typography sx={{fontWeight: completedCourse? 800 : 600, fontSize: completedCourse? "25px" : "20px", whiteSpace: "nowrap", textAlign: "center", lineHeight: completedCourse? "28.75px" : "26px"}}>{completedCourse? "Congrats, We See You Just Finished" : "We See That You Are Working on"}</Typography>
                            <Typography sx={{fontWeight: completedCourse? 800 : 600, fontSize: completedCourse? "25px" : "20px", whiteSpace: "normal", textAlign: "center", lineHeight: completedCourse? "28.75px" : "26px"}}>{accelName && !accelName?.includes("The") ? "The " + parse(accelName) : accelName && parse(accelName)} {scratchClubPage ? "Accelerator" : "Course"}</Typography>
                        </Grid>
                    }
                    {!promo?.promo_text && isMobile &&
                        <Grid className={styles.gridTitlePopupModal} item md={12} xs={12} padding={0} margin={0} sx={{padding:"30px 0 0 0"}}>
                            <Typography sx={{fontWeight: completedCourse? 800 : 600, fontSize: completedCourse? "25px" : "20px", whiteSpace: "nowrap", textAlign: "center", lineHeight: completedCourse? "28.75px" : "26px"}}>{completedCourse? "Congrats," : ""}</Typography>
                            <Typography sx={{fontWeight: completedCourse? 800 : 600, fontSize: completedCourse? "25px" : "20px", whiteSpace: "nowrap", textAlign: "center", lineHeight: completedCourse? "28.75px" : "26px"}}>{completedCourse? "We See You Just Finished" : "We See That You Are Working on"}</Typography>
                            <Typography sx={{fontWeight: completedCourse? 800 : 600, fontSize: completedCourse? "25px" : "20px", whiteSpace: "normal", textAlign: "center", lineHeight: completedCourse? "28.75px" : "26px"}}>{accelName && !accelName?.includes("The") ? "The " + parse(accelName) : accelName && parse(accelName)} {scratchClubPage ? "Accelerator" : "Course"}</Typography>
                        </Grid>
                    }
                </Grid>
                <Grid container padding={0} margin={0} sx={{position:"relative", marginTop:{md:"30px", xs:0}, backgroundColor: isMobile? 'rgba(255, 255, 255, 1)':'rgba(255, 255, 255, 0.6)', display: 'flex', flexDirection: 'row', paddingBottom:"20px", paddingLeft: { xs: 0, md: "20px" }, alignItems: 'center' }}>
                    <Grid item md={6} xs={12} padding={0} margin={0} sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <Card sx={{maxHeight:isMobile? "168px" : "192px", maxWidth:isMobile? "276px" :"316px", borderRadius:"unset", border: "5px solid white", outline: "1px solid #E6E6E6",
                                outlineOffset: "-1px"}} >
                            <CardMedia
                                sx={{ maxHeight:isMobile? "168px" : "192px", objectFit:"fill"}}
                                component="img"
                                alt="Random Course"
                                image={promo?.image}
                            />
                        </Card>
                    </Grid>
                    <Grid item md={6} xs={12} padding={0} margin={0} marginTop={isMobile? "10px":0} sx={{ display: 'flex', flexDirection: 'column', alignItems: {md:'center', xs:'unset'}, paddingLeft: { xs: "30px", md: 0 }, paddingRight: { xs: "30px", md: "40px" } }}>
                        <Grid item md={12} xs={12} padding={0} margin={0}>
                            <Typography sx={{fontWeight: 800, fontSize: "25px", lineHeight:"28.75px",mb:2}}>{promo?.name}</Typography>
                            <Typography sx={{fontWeight: 500, fontSize: "15px", lineHeight:"normal", mb: 2, letterSpacing: "-0.03px"}}>{promo?.course_desc? promo?.course_desc : promo?.promo_text}</Typography>
                        </Grid>
                        <Grid item md={12} xs={12} padding={0} margin={0} container>
                            <Button 
                                sx={{display: 'flex',alignItems: 'center',justifyContent: 'space-between'}} 
                                // sku: string, accelerator:Accelerator, lesson:Lesson, location:string
                                onClick={() => {completedCourse? clickFinishedtProductRecommendation("", accelerator, currentLesson, "Pop Up") : clickProduct(source === "player" ? "Video" : "Course Page", "Pop Up", "", promo?.ID, promo?.name, "In Video"); promo?  window.location.href = promo?.url: console.log("no url");}}
                            // { navigate(`${currentPromo?.url}`);}}
                                    className={styles.nextBtn} fullWidth>
                                <LockIcon sx={{color:"white"}} style={{ marginLeft: 0 }}></LockIcon>
                                <Typography sx={{fontWeight: 700, whiteSpace: "nowrap", flexGrow: 1, textAlign: 'center'}}>Unlock Now</Typography>
                            </Button>
                        </Grid>
                    </Grid>
                    
                </Grid>
                <Button sx={{margin: isMobile? "7px auto":"20px auto", display: "block", textAlign: "center", textDecoration:"none", textTransform: 'none'}} onClick={() => {if (callback) {
                                        callback(!value1)
                                    }}}                 
                >
                    <Typography sx={{fontWeight: 700, whiteSpace: "nowrap"}}>Close</Typography>
                </Button>
            </Box>
        </Box>
    </Box>    
    )
};


export default PopUpDialog;